import { authenticationTypes } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { deliveryRatioEndpointIds } from 'root/src/shared/deliveryRatio/deliveryRatio.constants';
export const adminIncreaseDeliveryRatioEndpoint = {
    [deliveryRatioEndpointIds.ADMIN_INCREASE_DELIVERY_RATIO]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: [AuthGroup.Admin],
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
                creatorUserId: { type: 'string' },
            },
            required: ['dropId', 'creatorUserId'],
        },
        endpointType: otherEndpointType,
    },
};
